import type { ComponentType, PropsWithChildren } from "react";
import { RouterProvider, type createBrowserRouter } from './lib';

export const withRouter = (
    Component: ComponentType<PropsWithChildren>,
    factory: () => ReturnType<typeof createBrowserRouter>
) => {
    const router = factory();

    return () => (
        <Component>
            <RouterProvider
                router={router}
                future={{
                    v7_startTransition: true
                }}
            />
        </Component>
    );
};

export default withRouter;
